import { FC, forwardRef, useImperativeHandle, useState } from 'react';
import { Spin } from 'antd';
import V2Container from '@/common/components/Data/V2Container';
import { useMethods } from '@lhb/hook';
import DetailMain from './components/DetailMain/index';
import styles from './entry.module.less';
import { getClusterAndDirectTaskDetail } from '@/common/api/expandStore/clusterAndDirect';
import Header from './components/Header';

/**
 * 拓店任务：加盟+直营模板A-详情
 */
const Detail: FC<{
  id,
  // onClose?,
  reload?,
  isHistory?,
  hideOperate?,
  hideClusterDetail?,
  ref?: any,
}> = forwardRef(({ id, reload, isHistory, hideOperate, hideClusterDetail }, ref) => {
  const [innerMainHeight, setInnerMainHeight] = useState<number>(0);

  const [loading, setLoading] = useState<boolean>(false);
  const [detail, setDetail] = useState<any>({});


  useImperativeHandle(ref, () => ({
    init: methods.init
  }));


  const methods = useMethods({

    /**
     * @description 初始化
     */
    init: () => {
      if (!id) {
        return;
      }
      methods.loadData(id);
    },

    loadData: async (id: number) => {
      setLoading(true);
      const data = await getClusterAndDirectTaskDetail({ id });
      setLoading(false);
      setDetail(data);
    },
    /**
     * @description 重新加载
     * @param status 状态 true 需要加载详情， false 不需要加载详情
     * @return
     */
    reload(status = true) {
      if (status) methods.init();

      reload?.();
    }
  });

  return (<>
    <Spin tip='数据正在加载中请稍等......' spinning={loading}>
      <V2Container
        emitMainHeight={(h) => setInnerMainHeight(h)}
        extraContent={{
          top: <Header
            isHistory={isHistory}
            hideOperate={hideOperate}
            detail={detail}
            onRefresh={() => methods.reload(true)}
          />,
        }}
        style={{ height: 'calc(100vh - 48px)', width: '100%' }}
        className={styles.container}>

        <DetailMain
          style={{
            height: innerMainHeight || 'auto',
            overflowY: 'scroll',
            overflowX: 'hidden',
            marginTop: '16px',
          }}
          detail={detail}
          hideOperate={hideOperate}
          hideClusterDetail={hideClusterDetail}
          // onClose={onClose}
          refresh={() => methods.reload(true)} />
      </V2Container>
    </Spin>
  </>);
});

export default Detail;
